import pathOr from 'ramda/es/pathOr';
import {API, LOADING} from '../constants';

export default (key, initialState = false) =>
  pathOr(initialState, [API, key, LOADING]);
